import React from 'react';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import Page from 'components/page/page.component';

import Administrator from './positions/administrator.position';

import './style.css';

const Partners = () => {
    return (
        <Page
            className="jobs"
            heroTitle="Job Opportunities"
            heroText="Below are the positions and services we are actively seeking"
            heroSize="small"
            variant="no-flex"
        >
            <Tabs defaultActiveKey="administrator">
                <Tab eventKey="administrator" title="Muncie Land Bank Administrator">
                    <Administrator />
                </Tab>
            </Tabs>
        </Page>
    );
};

export default Partners;
